import React, { Component } from 'react';

class TabPane extends Component {
    render() {
        return (
            <div className="TabPane">
              {this.props.children}
            </div>
        )
    }
}

TabPane.defaultProps = {
  handleClick: () => void(0)
};

export default TabPane;